import React from 'react'
import { PageHeading } from 'app/layout/PageHeading'
import { InfoPageSection } from 'app/layout/InfoPageSection'

export const PrivateLessonsPage = () => (
  <section tabIndex={0}>
    <PageHeading title='Private Lessons' image='stlswing/erin-workshop.jpg' />

    <InfoPageSection
      title='Coming soon'
      text='We are still setting up the software that will allow online sign-ups for private lessons. Check back in a few weeks!'
    />
  </section>
)

export default PrivateLessonsPage
